
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import ModalContent from '@/components/modal/ModalContentNew.vue';
import ModalFullScreen from '@/components/modal/ModalFullScreenNew.vue';
import UiButton from '@/components/button/ui-button.vue';
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';
import FormDatepicker from '@/components/form/FormDatepickerNew.vue';
import INSERT_PROJECT_ACTIVITY_TIME from '@/apollo/projectActivities/InsertProjectActivityTime.gql';
import GET_PROJECT_ACTIVITY_TIMES from '@/apollo/projectActivities/GetProjectActivityTimes.gql';
import GET_PROJECT_ACTIVITY_REQUEST_MORE_HOURS from '@/apollo/projectActivities/GetRequstedHours.gql';
import UPDATE_PROJECT_ACTIVITY_TIME from '@/apollo/projectActivities/UpdateProjectActivityTime.gql';
import UPDATE_PROJECT_ACTIVITY_REQUEST_MORE_HOURS from '@/apollo/projectActivities/ProjectActivityRequestMoreHours.gql';
import DELETE_PROJECT_ACTIVITY_TIME from '@/apollo/projectActivities/DeleteProjectActivityTime.gql';
import GET_PROJECT_ACTIVITY_TIMES_BY_CONTRACTOR from '@/apollo/projectActivities/GetProjectActivityTimesByContractor.gql';
import moment from 'moment';
import GET_CONTRACTOR_ACTIVITIES from '@/apollo/projectActivities/GetContractorActivities.gql';
import GET_CONTRACTOR_PROJECTS from '@/apollo/projects/GetContractorProjects.gql';
import DELETE_PROJECT_ACTIVITY_REQUEST_MORE_HOURS from '@/apollo/projectActivities/DeleteProjectActivityRequestedHours.gql';
import DropdownFilter from '@/components/filters/DropdownFilterNew.vue';
import DropdownOption from '@/entities/DropdownOption';
import PROJECT_ACTIVITY_TIME_AGGREGATE from '@/apollo/projectActivities/ProjectActivityTimeAggregate.gql';
import PROJECT_ACTIVITY_REQUEST_MORE_HOURS_AGGREGATE from '@/apollo/projectActivities/ProjectActivityRequestMoreHoursAggregate.gql';
import {
	Project_Activity,
	Project,
	Project_Activity_Time,
	Project_Activity_Request_More_Hours,
	User,
} from '@/generated/graphql';
import convertSecondsToReadable from '@/utils/convertSecondsToReadable';
import GET_PROJECT_BY_COMPANY from '@/apollo/projects/GetProjectByCompanyId.gql';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import TimeTrackingDelete from '@/components/icons/TimeTrackingDelete.vue';
import Spinner from '@/components/common/Spinner.vue';
import TimeTrackingEdit from '@/components/icons/TimeTrackingEdit.vue';
import NewTimePicker from '@/components/projects/timeTracker/NewTimePickerNew.vue';
import INSERT_PROJECT_ACTIVITY_MORE_HOURS_REQUEST from '@/apollo/projectActivities/InsertProjectActivityRequestMoreHours.gql';
import { NOTIFICATION } from '@/entities/Events';
import Message from '@/data/notificationsMessages';

@Component({
	components: {
		ModalContent,
		UiButton,
		TimeTrackingDelete,
		ModalFullScreen,
		LoadingOverlay,
		VueTimepicker,
		TimeTrackingEdit,
		DropdownFilter,
		FormDatepicker,
		Spinner,
		NewTimePicker,
	},
	apollo: {
		trackedTimes: {
			query: GET_PROJECT_ACTIVITY_TIMES,
			variables() {
				return {
					activityId: this.activity?.id,
				};
			},
			skip() {
				return !this.activity;
			},
			update: (data) => data.project_activity_time,
		},
		timeAggregate: {
			query: PROJECT_ACTIVITY_TIME_AGGREGATE,
			variables() {
				return {
					activityId: this.activity?.id,
				};
			},
			skip() {
				return !this.activity;
			},
			update: (data) =>
				data.project_activity_time_aggregate.aggregate.sum.time,
		},

		hoursAggregate: {
			query: PROJECT_ACTIVITY_REQUEST_MORE_HOURS_AGGREGATE,
			variables() {
				return {
					activityId: this.activity?.id,
				};
			},
			skip() {
				return !this.activity;
			},
			update: (data) =>
				data.project_activity_request_more_hours_aggregate.aggregate.sum
					.hours,
		},
		contractor_projects: {
			query: GET_PROJECT_BY_COMPANY,
                    variables() {
						return {
                        company_id: this.companId,
                    };
					},
			update(data) {
				return data.project;
			},
		},
		allTrackedTimes: {
			query: GET_PROJECT_ACTIVITY_TIMES_BY_CONTRACTOR,
			variables() {
				return {
					userID: this.currentUser.id,
				};
			},
			update(data) {
				return data.project_activity_time;
			},
		},
		contractor_activities: {
			query: GET_CONTRACTOR_ACTIVITIES,
			variables() {
				return {
					where: {
						contractor: {
							user_id: { _eq: this.currentUser.id },
						},
						_and: {
							project: {
								id: { _eq: this.project[0]?.id },
							},
						},
						deleted: { _eq: false},
					},
				};
			},
			skip() {
				return !this.project;
			},
			update(data) {
				return data.project_activity;
			},
		},
	},
})
export default class TimesheetTimeTrackerModal extends Vue {
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: Object, required: false })
	readonly activeActivity!: Project_Activity;
	@Prop({ type: Boolean, required: true }) readonly canPause!: boolean;
	@Prop({ type: Object, required: false })
	readonly activeTimeEntry!: Project_Activity_Time;
	@Prop({ type: Date, required: false }) propDate: Date;
	@Prop({ type: String, required: false }) propRangeStart: string;
	@Prop({ type: String, required: false }) companId: string;
	@Prop({ type: String, required: false }) timesheetId: string;
	@Prop({ type: String, required: false }) propRangeEnd: string;
	@Prop({ type: Date, required: false }) currentCellTime: Date;
	@Prop({ type: Function, required: false }) checkDateWeekDisable?: Function;


@Watch("companyId", {immediate: true})
onSelectedCompanyChanged(){
if (this.companyId) {
            this.$apollo
                .query({
                    query: GET_PROJECT_BY_COMPANY,
                    variables: {
                        company_id: this.companId,
                    },
                })
                .then(({ data }) => {
                    this.contractor_projects = data.project;
                })
                .catch((error) => {});
}
}

	allTrackedTimes: Project_Activity_Time[] = [];
	rangeTracker = false;
	timerTracker = true;
	companyId: string | number = 0;
	manualTracker = false;
	requestHoursSlot = false;
	loading = false;
	contractor_projects: Project[] = [];
	contractor_activities: Project_Activity[] = [];
	activity: Project_Activity = this.activeActivity
		? this.activeActivity
		: null;
	project: DropdownOption[] = this.activeActivity
		? [
				{
					name: this.activeActivity.project.name,
					id: this.activeActivity.project.id,
				},
		  ]
		: [];
	activeClasses = 'activeClass';
	rangeTrackerClasses = '';
	timerTrackerClasses = '';
	manualTrackerClasses = '';
	timeTrackedArray?: { status: String; date: String; time: String }[] = [
		{ status: 'approved', date: '02/02/2022', time: '12.23.23' },
		{ status: 'rejected', date: '02/02/2022', time: '12.23.23' },
		{ status: 'pending', date: '02/02/2022', time: '12.23.23' },
		{ status: 'approved', date: '02/02/2022', time: '12.23.23' },
		{ status: 'rejected', date: '02/02/2022', time: '12.23.23' },
		{ status: 'pending', date: '02/02/2022', time: '12.23.23' },
	];
	rangeStart: string = this.propRangeStart
		? this.propRangeStart.toString()
		: '00:00:00';
	rangeEnd: string = this.propRangeEnd
		? this.propRangeEnd.toString()
		// : '00:00:01';
		: '00:01:00';
	tracked_date: Date = this.propDate ? this.propDate : new Date();
	notes: string = '';
	time: number = this.timeSelect;
	manualTimeInput: string = '00:00:00';
	trackedTimes: Project_Activity_Time[] = undefined;
	id: string = '';
	status: string = 'CREATED';
	timeAggregate: number = 0;
	hoursAggregate: number = 0;
	timerRunning: boolean = false;
	timerPaused: boolean = false;
	timerResumed: boolean = false;
	pausedTime: Date = localStorage.getItem('pausedTime')
		? new Date(localStorage.getItem('pausedTime'))
		: new Date();
	resumedTime: Date = localStorage.getItem('resumedTime')
		? new Date(localStorage.getItem('resumedTime'))
		: new Date();
	timerStart: Date = localStorage.getItem('startTime')
		? new Date(localStorage.getItem('startTime'))
		: new Date();
	timerStop: Date = localStorage.getItem('stopTime')
		? new Date(localStorage.getItem('stopTime'))
		: new Date();
	timerRecorded: boolean = false;
	processing: boolean = false;
	convertSecondsToReadable = convertSecondsToReadable;
	reason: string = '';
	requestTimeInput: string = '00:00:00';

	timerLabel: string = "00:00:00";

	setTimerLabelValue() {
		this.timerLabel = this.convertSecondsToReadable(this.activeTimeEntry.time);
		this.rangeStart = this.activeTimeEntry.start_time;
		this.rangeEnd = this.activeTimeEntry.end_time;
		this.notes = this.activeTimeEntry.notes;
		this.timerRecorded = true;
		this.tracked_date = this.activeTimeEntry.tracked_date;
	}






	@Watch("contractor_activities", { immediate: true })
	cprojectd(){
				if (this.activeTimeEntry?.activity_id) {

		this.activity =  this.contractor_activities.find(
				(activity) => activity.id === this.activeTimeEntry.activity_id
			);
		this.timerRecorded = true

		this.id = this.activeTimeEntry?.id;

				}
	}



	get project_options(): DropdownOption[] {
		return this.contractor_projects.map((project) => {
			return {
				name: project.client_name,
				id: project.id,
			};
		});
	}
	get activity_options(): DropdownOption[] {
		return this.contractor_activities.map((activity) => {
			return {
				name: moment(activity.start_date).format('DD/MM/YYYY'),
				id: activity.id,
			};
		});
	}
	get timeSelect(): number {
		if (this.rangeTracker) {
			return this.rangeTime;
		}
		if (this.manualTracker) {
			return this.manualTime;
		}
		if (this.timerTracker) {
			return this.timerTime;
		}
		if (this.requestHoursSlot) {
			return this.requestHoursTime;
		}
		return 0;
	}
	get project_option() {
		return this.project;
	}
	get activity_option() {
		if (this.activity) {
			return [{ name: this.activity.title, id: this.activity.id }];
		}
		return [];
	}
	setProject(input: DropdownOption[]) {
		this.project = input;
		this.activity = null;
		this.$apollo.queries.contractor_activities.refetch();
	}
	setActivities(input: DropdownOption[]) {
		this.activity = this.contractor_activities.find(
			(activity) => activity.id === input[0].id
		);
	}
	get canSave(): boolean {
		if (this.timerTracker && this.timerRecorded && this.timeSelect > 0) {
			return true;
		}
		if (this.manualTracker && this.rangeStart < this.rangeEnd) {
			return true;
		}
		if (
			this.rangeTracker &&
			this.timeSelect &&
			this.rangeStart < this.rangeEnd
		) {
			return true;
		}
		if (this.requestHoursSlot && this.timeSelect > 0 && this.reason) {
			return true;
		}
		return false;
	}

	isTimeAddedAlreadyStyle(requestHoursSlot, timeAggregate, hoursAggregate) {
		let result;
		if (
			requestHoursSlot
				? convertSecondsToReadable(hoursAggregate) !== '00:00:00'
				: convertSecondsToReadable(timeAggregate) !== '00:00:00'
		) {
			result = 'w-auto xl:border-r-1 xl:border-gray-300 pr-4';
		} else {
			result = 'w-full';
		}
		return result;
	}

	//   isTimeAddedAlready(requestHoursSlot, timeAggregate, hoursAggregate) {
	//     this.loading = true;
	//     let result;

	//     result = requestHoursSlot
	//       ? convertSecondsToReadable(hoursAggregate) !== "00:00:00"
	//       : convertSecondsToReadable(timeAggregate) !== "00:00:00";
	//     this.loading = !this.loading;
	//     return result;
	//   }

	created(): void {
		if(!this.activeActivity && !this.activeTimeEntry && this.currentCellTime){
			this.tracked_date = new Date(this.currentCellTime)
		}
		if ((this.propDate, this.propRangeStart, this.propRangeEnd)) {
			this.tracked_date = this.propDate;
			this.rangeStart = this.propRangeStart;
			this.rangeEnd = this.propRangeEnd;
			this.rangeTracker = true;
			this.timerTracker = false;
			this.rangeTrackerClasses = this.activeClasses;
		}else {
			this.timerTrackerClasses = this.activeClasses;
		}
		if (
			localStorage.getItem('timerRecorded') &&
			localStorage.getItem('timerRecorded') === '1'
		) {
			this.timerRecorded = true;
		} else {
			this.timerRecorded = false;
		}
		if (this.activeTimeEntry) {
				// this.setToEdit(this.activeTimeEntry);
				this.showTimerSlot()
				
				this.project = this.activeTimeEntry
					? [
						{
							name: this.activeTimeEntry.project_activity.project.name,
							id: this.activeTimeEntry.project_activity.project?.id,
						},
					]
					: [];
					this.setTimerLabelValue();

			}

		if (
			localStorage.getItem('timerRecorded') &&
			localStorage.getItem('timerRunning') === '1'
		) {
			this.timerRunning = true;
		} else {
			this.timerRunning = false;
		}
		if (this.timerRunning && !localStorage.getItem('timerInterval')) {
			this.displayTimer();
		}
		if (localStorage.getItem('timerInterval')) {
			var timerInterval = Number(localStorage.getItem('timerInterval'));
			window.clearInterval(timerInterval);
			localStorage.removeItem('timerInterval');
			this.displayTimer();
		}
	}

	closeModal(): void {
		if (this.timerRecorded && this.timerTracker)
			if (localStorage.getItem('timerInterval')) {
				var timerInterval = Number(
					localStorage.getItem('timerInterval')
				);
				window.clearInterval(timerInterval);
				localStorage.removeItem('timerInterval');
			}

		// window.location.reload();
		this.$emit('close');
	}
	changeSlotCommon(){
			this.timerTracker = false;
			this.rangeTracker = false;
			this.requestHoursSlot = false;
			this.manualTracker = false;
			this.rangeTrackerClasses = '';
			this.timerTrackerClasses = '';
			this.manualTrackerClasses = '';
	}
	resetPage(): void {
		this.rangeStart = '00:00:00';
		this.rangeEnd = '00:01:00';
		this.notes = '';
		this.tracked_date = this.tracked_date ||  new Date();
		this.manualTimeInput = '00:00:00';
		this.requestTimeInput = '00:00:00';
		this.id = '';
		this.status = 'CREATED';
		this.timerStart = this.tracked_date ||  new Date();
		this.timerStop = this.tracked_date ||  new Date();
		this.timerRunning = false;
		this.timerRecorded = false;
		this.timerPaused = false;
		this.timerResumed = false;
		this.processing = false;
		this.reason = '';
		this.refetchData();
		this.discardTimer();
	}

	showTimerSlot(): void {
		if (!this.activeTimeEntry) {
			this.resetPage();
		}
		this.changeSlotCommon()
		this.timerTracker = true;
		this.timerTrackerClasses = this.activeClasses;
	}
	showRangeSlot(): void {
		if (!this.activeTimeEntry) {
			
			this.resetPage();
		}
		this.changeSlotCommon()
		this.rangeTracker = true;
		this.rangeTrackerClasses = this.activeClasses;
	}
	showManualSlot(): void {
		if (!this.activeTimeEntry) {
			
			this.resetPage();
		}
		this.changeSlotCommon()
		this.manualTracker = true;

		this.manualTrackerClasses = this.activeClasses;
	}

	get buttonText(): string {
		if (this.timerTracker && this.timerRunning && this.activeTimeEntry && this.canPause) {
		return 'Pause';
	}
		if (this.timerTracker && this.timerRunning) {
			return 'Stop Timer';
		}
		if (this.timerTracker && this.timerRecorded) {
			return 'Submit';
		}
		if (this.timerTracker) {
			return 'Start Timer';
		}
		return 'Save';
	}

	get buttonStartTimer(): String {
		if (this.timerRunning && this.canPause) {
			return 'Pause';
		}
		if (this.canPause && !this.timerRunning) {
			return 'Resume';
		}
		if (this.timerRunning) {
			return 'Stop';
		}

		return 'Start';
	}

	get rangeTime(): number {
		if (!this.rangeStart || !this.rangeEnd) {
			return 0;
		}
		var rangeStart = this.rangeStart
			.replace('HH', '00')
			.replace('mm', '00')
			.replace('ss', '00');
		var rangeEnd = this.rangeEnd
			.replace('HH', '00')
			.replace('mm', '00')
			.replace('ss', '00');
		var start = rangeStart.split(':');
		var end = rangeEnd.split(':');
		var startDate = new Date(
			0,
			0,
			0,
			Number(start[0] ? start[0] : 0),
			Number(start[1] ? start[1] : 0),
			Number(start[2] ? start[2] : 0)
		);
		var endDate = new Date(
			0,
			0,
			0,
			Number(end[0] ? end[0] : 0),
			Number(end[1] ? end[1] : 0),
			Number(end[2] ? end[2] : 0)
		);
		var diff = endDate.getTime() - startDate.getTime();
		this.rangeStart = this.rangeStart
			.replace('HH', '00')
			.replace('mm', '00')
			.replace('ss', '00');
		this.rangeEnd = this.rangeEnd
			.replace('HH', '00')
			.replace('mm', '00')
			.replace('ss', '00');
		return diff / 1000;
	}

	get manualTime(): number {
		return this.rangeTime
		// if (!this.manualTimeInput) {
		// 	return 0;
		// }

		// var manualTimeInput = this.manualTimeInput
		// 	.replace('HH', '00')
		// 	.replace('mm', '00')
		// 	.replace('ss', '00');
		// var times = manualTimeInput.split(':');
		// this.manualTimeInput = this.manualTimeInput
		// 	.replace('HH', '00')
		// 	.replace('mm', '00')
		// 	.replace('ss', '00');
		// return (
		// 	Number(times[2]) +
		// 	Number(times[1]) * 60 +
		// 	Number(times[0]) * 60 * 60
		// );
	}
	get requestHoursTime(): number {
		if (!this.requestTimeInput) {
			return 0;
		}
		var requestTimeInput = this.requestTimeInput
			.replace('HH', '00')
			.replace('mm', '00')
			.replace('ss', '00');
		var times = requestTimeInput.split(':');
		this.requestTimeInput = this.requestTimeInput
			.replace('HH', '00')
			.replace('mm', '00')
			.replace('ss', '00');
		return (
			Number(times[2]) +
			Number(times[1]) * 60 +
			Number(times[0]) * 60 * 60
		);
	}
	get timerTime(): number {
		if (!this.timerStart || !this.timerStop) {
			return 0;
		}
		var diff = this.timerStop.getTime() - this.timerStart.getTime();
		return diff / 1000;
	}

	get getTitle() {
		return this.activity?.title;
	}
	async pauseTime() {}
	async saveTimeTrack(): Promise<void> {
		const isDisable = this.checkDateWeekDisable?.(this.tracked_date)
		if (isDisable) {
			this.$eventBus.emit(
				NOTIFICATION,
				Message.errorMessage(
					"The timesheet status must be open for the period: " + this.tracked_date.toDateString()
				)
			);
			return;
		}
		if (this.checkForTimeOverlap()) {
			return;
		}
		this.processing = true;
		const starttime = this.rangeStart?.split(':');
		const endTime = this.rangeEnd?.split(':');
			if (starttime?.length < 3) {
				this.rangeStart = `${this.rangeStart}:00`
			}
			if (endTime?.length < 3) {
			this.rangeEnd = `${this.rangeEnd}:00`
			}
		if (!this.id) {
			var projectActivityTime = {
				activity_id: this.activity.id,
				contractor_id: this.activity.contractor_id,
				start_time: this.rangeStart,
				end_time: this.rangeEnd,
				notes: this.notes,
				time: this.timeSelect,
				timesheet_id:  this.timesheetId,
				tracked_date: moment(this.tracked_date)
					.local()
					.format('YYYY-MM-DD'),
			};
			await this.$apollo.mutate({
				mutation: INSERT_PROJECT_ACTIVITY_TIME,
				variables: {
					projectActivityTime: projectActivityTime,
				},
			});
			this.$eventBus.emit(
				NOTIFICATION,
				Message.successMessage(
					'Time tracked has been successfully added'
				)
			);
		}
		if (this.id) {
			var obj = {
				activity_id: this.activity.id,
				time: this.timeSelect,
				start_time: this.rangeStart,
				end_time: this.rangeEnd,
				status: this.status,
				notes: this.notes,
				tracked_date: moment(this.tracked_date)
					.local()
					.format('YYYY-MM-DD'),
			};
			await this.$apollo.mutate({
				mutation: UPDATE_PROJECT_ACTIVITY_TIME,
				variables: {
					id: this.id,
					obj: obj,
				},
			});
			this.$eventBus.emit(
				NOTIFICATION,
				Message.successMessage(
					'Time tracked has been successfully updated'
				)
			);
		}
		this.resetPage();
		this.$apollo.queries.allTrackedTimes.refetch();
		this.$emit('close');
	}
	checkForTimeOverlap() {
		let overlap = false;
		this.allTrackedTimes.forEach((time) => {
			if (this.id !== time.id) {
				if (
					moment(this.tracked_date).format('YYYY-MM-DD') ==
					time.tracked_date
				) {
					if (
						this.rangeStart > time.start_time &&
						this.rangeStart < time.end_time
					) {
						overlap = true;
						this.$eventBus.emit(
							NOTIFICATION,
							Message.errorMessage(
								'Time overlap with ' +
									time.project_activity.title
							)
						);
						return overlap;
					}
					if (
						this.rangeEnd > time.start_time &&
						this.rangeEnd < time.end_time
					) {
						overlap = true;
						this.$eventBus.emit(
							NOTIFICATION,
							Message.errorMessage(
								'Time overlap with ' +
									time.project_activity.title
							)
						);
						return overlap;
					}
					if (
						this.rangeStart < time.start_time &&
						this.rangeEnd > time.end_time
					) {
						overlap = true;
						this.$eventBus.emit(
							NOTIFICATION,
							Message.errorMessage(
								'Time overlap with ' +
									time.project_activity.title
							)
						);
						return overlap;
					}
				}
			}
		});
		return overlap;
	}

	deleteTrackedTime(id: string): void {
		this.$confirm({
			title: `Delete tracked time for task ${this.activity.title}`,
			message: `Are you sure?`,
			button: {
				no: 'No',
				yes: 'Yes',
			},
			callback: async (confirm: any) => {
				if (confirm) {
					await this.$apollo.mutate({
						mutation: DELETE_PROJECT_ACTIVITY_TIME,
						variables: {
							id: id,
						},
					});
					this.refetchData();
				}
			},
		});
		this.$apollo.queries.trackedTimes.refetch();
		this.$apollo.queries.allTrackedTimes.refetch();
	}
	deleteRequestedHours(id: string): void {
		this.$confirm({
			title: `Delete requested hours for task ${this.activity.title}`,
			message: `Are you sure?`,
			button: {
				no: 'No',
				yes: 'Yes',
			},
			callback: async (confirm: any) => {
				if (confirm) {
					await this.$apollo.mutate({
						mutation: DELETE_PROJECT_ACTIVITY_REQUEST_MORE_HOURS,
						variables: {
							id: id,
						},
					});
					this.refetchData();
				}
			},
		});
	}

	refetchData(): void {
		this.$apollo.queries.trackedTimes.refetch();
		this.$apollo.queries.timeAggregate.refetch();
		this.$apollo.queries.hoursAggregate.refetch();
		this.$emit('timesChanged');
	}

	convertDateString(date: string): string {
		// date = date.replace("-", "/").replace("-", "/");
		var parts = date.split('-');
		// return date;
		return parts[2] + '/' + parts[1] + '/' + parts[0];
	}

	setToEdit(time: Project_Activity_Time): void {
		this.showManualSlot();
		this.id = time.id;
		this.notes = time.notes;
		this.tracked_date = new Date(
			moment(time.tracked_date).local().toDate()
		);
		this.rangeStart = time.start_time;
		this.rangeEnd = time.end_time;
		this.status = time.status;
	}


	startStopButton() {
		const isDisable = this.checkDateWeekDisable?.(this.tracked_date)
		if (isDisable) {
			this.$eventBus.emit(
				NOTIFICATION,
				Message.errorMessage(
					"The timesheet status must be open for the period: " + this.tracked_date.toDateString()
				)
			);
			return;
		}
		if (!this.timerTracker) {
			this.saveTimeTrack();

			this.closeModal();
		}
		if (this.timerRunning  && this.activeTimeEntry) {
			this.startStopTimer();
			return;
		}
		if (this.timerRecorded && !this.timerRunning) {
			this.saveTimeTrack();
			this.closeModal();
			return;
		}
		if (!this.timerRunning) {
			this.startStopTimer();
			this.closeModal();
		} else {
			this.startStopTimer();
		}
	}

	 getCurrentTimeWithTrackDate() {
			let timedActivity = localStorage.getItem('activity')
			? JSON.parse(localStorage.getItem('activity'))
			: undefined;
			const tDate = timedActivity?.tracked_date || this.tracked_date
			if(tDate){
				const trackedDate = new Date(tDate);
				const currentTime = new Date();
				const currseconds = currentTime.getSeconds();
				const currminutes = currentTime.getMinutes();
				const currhours= currentTime.getHours();
				const currmilis= currentTime.getMilliseconds();
				trackedDate.setHours(currhours);
				trackedDate.setSeconds(currseconds);
				trackedDate.setMinutes(currminutes);
				trackedDate.setMilliseconds(currmilis)
				return trackedDate
			}
			return new Date()
		}
	startStopTimer(): void {
		const isDisable = this.checkDateWeekDisable?.(this.tracked_date)
		if (isDisable) {
			this.$eventBus.emit(
				NOTIFICATION,
				Message.errorMessage(
					"The timesheet status must be open for the period: " + this.tracked_date.toDateString()
				)
			);
			return;
		}
		let timedActivity = localStorage.getItem('activity')
			? JSON.parse(localStorage.getItem('activity'))
			: undefined;
			const timeWithTrackedDate = this.getCurrentTimeWithTrackDate()
		if (
			!timedActivity ||
			(timedActivity && timedActivity.id === this.activity.id)
		) {
			if (this.timerRunning && this.canPause) {
				//save the timer right away
				this.timerPaused = !this.timerPaused;
				if (this.timerPaused) {
					localStorage.setItem('pausedTime', timeWithTrackedDate.toString());
					this.timerStop = timeWithTrackedDate;
					this.$root.$emit('timerPaused');
					this.timerRunning = false;
					localStorage.setItem('timerRunning', '0');
					localStorage.setItem('timerPaused', '1');
				} else {
					localStorage.setItem('resumedTime', timeWithTrackedDate.toString());
					this.timerStart = new Date(
						localStorage.getItem('pausedTime')
					);
					this.timerRunning = true;
					this.timerStop = timeWithTrackedDate;
					this.$root.$emit('timerResumed');
					localStorage.setItem('timerRunning', '1');
					localStorage.setItem('timerPaused', '0');
				}
			}
			if (!this.timerRunning) {
				if (localStorage.getItem('timerInterval')) {
					var timerInterval = Number(
						localStorage.getItem('timerInterval')
						);
						window.clearInterval(timerInterval);
					}
					this.timerRunning = !this.timerRunning;
					this.timerStart = new Date(
						localStorage.getItem('startTime') || this.resetStartTime()
						);
						if (!localStorage.getItem('timerInterval')) {
							this.displayTimer();
						}
					} else {
				if (localStorage.getItem('timerInterval')) {
					var timerInterval = Number(
						localStorage.getItem('timerInterval')
					);
					window.clearInterval(timerInterval);
				}
				this.timerRunning = !this.timerRunning;
				this.timerStart = new Date(localStorage.getItem('startTime'));
				this.timerStop = timeWithTrackedDate;
				this.rangeEnd= this.timerStop.toTimeString().split(" ")[0],
					this.rangeStart= this.timerStart.toTimeString().split(" ")[0],
				this.$root.$emit('timerStopped');
				localStorage.setItem('stopTime', this.timerStop.toString());
				this.timerRecorded = true;
				localStorage.setItem('timerRecorded', '1');
				localStorage.setItem('timerRunning', '0');
			}
		} else {
			alert(
				"A timer is already running for task '" +
					timedActivity.title +
					"'.\nPlease attend to that first."
			);
		}
	}
	//Add a new entry in local storage called timer paused and resumed, and subtract the time between paused and resumed from the start and end time

	displayTimer(): void {
		var timerInterval = window.setInterval(() => {
			// if (document.getElementById('modaltimerLabel')) {
				// document.getElementById('modaltimerLabel').innerHTML =
				// 	this.getTimer();
				this.timerLabel = this.getTimer()
			// }
		}, 1000);
		localStorage.setItem('timerInterval', timerInterval.toString());
		if (!localStorage.getItem('activity')) {
			localStorage.setItem('activity', JSON.stringify({ ...this.activity, timesheetId: this.activeTimeEntry?.timesheet_id ||  this.timesheetId, isEdit: this.activeTimeEntry ? true: false,  company_id: this.companId, activity_id: this.id}));
		}
		if (!localStorage.getItem('tracked_date')) {
			localStorage.setItem('tracked_date', this.tracked_date.toString());
		}
		if (!localStorage.getItem('timerOwner')) {
			localStorage.setItem('timerOwner' + this.currentUser.id, '1');
		}
		this.$root.$emit('timerStarted');
	}

	resetStartTime() {
		var startTime = this.tracked_date ?  this.getCurrentTimeWithTrackDate(): new Date();
		localStorage.setItem('startTime', startTime.toString());
		localStorage.setItem('timerRecorded', '0');
		localStorage.setItem('timerRunning', '1');
		return startTime;
	}
	secondsBetweenTimeStrings(rangeStart, rangeEnd) {
		const format = 'HH:mm:ss';
		const startTime = moment(rangeStart, format);
		const endTime = moment(rangeEnd, format);
		return endTime.diff(startTime, 'seconds');
	}

	discardTimer(): void {
		this.timerStart = new Date();
		this.timerStop = new Date();
		this.timerRunning = false;
		localStorage.removeItem('startTime');
		localStorage.removeItem('stopTime');
		localStorage.removeItem('timerRecorded');
		localStorage.removeItem('timerRunning');
		localStorage.removeItem('activity');
		localStorage.removeItem('appTimer');
		localStorage.removeItem('timerOwner' + this.currentUser.id);
		// if (document.getElementById('modaltimerLabel')) {
		// 	document.getElementById('modaltimerLabel').innerHTML = '00:00:00';
			this.timerLabel = '00:00:00'
		// }
		localStorage.removeItem('tracked_date');
		this.timerRecorded = false;
		this.$root.$emit('timerStopped');

		if (localStorage.getItem('timerInterval')) {
			var timerInterval = Number(localStorage.getItem('timerInterval'));
			window.clearInterval(timerInterval);
			localStorage.removeItem('timerInterval');
		}
	}

	getTimer(): string {
		var secsDiff = 0;
		if (!this.timerRunning && this.timerStart && this.timerStop) {
			secsDiff = this.timerStop.getTime() - this.timerStart.getTime();
			secsDiff = secsDiff / 1000;
		}
		if (this.timerStart && (!this.timerStop || this.timerRunning)) {
			const trackedDate  = this.getCurrentTimeWithTrackDate()

			secsDiff = trackedDate.getTime() - this.timerStart.getTime();
			secsDiff = secsDiff / 1000;
		}
		return this.convertSecondsToReadable(secsDiff);
	}

	get showTrackingModes(): { title: string; project: string } {
		let timedActivity = localStorage.getItem('activity')
			? JSON.parse(localStorage.getItem('activity'))
			: undefined;
			if( this.id && (timedActivity && timedActivity?.activity_id !== this.id)){
			return {
				title: timedActivity.title,
				project:
					timedActivity.project && timedActivity.project.name
						? timedActivity.project.name
						: '',
			};
			}
		if (
			!timedActivity ||
			(timedActivity && timedActivity?.id === this.activity?.id)
		) {
			return { title: '', project: '' };
		}
		return {
			title: timedActivity.title,
			project:
				timedActivity.project && timedActivity.project.name
					? timedActivity.project.name
					: '',
		};
	}

	get rangeEndHourRange(): Number[] {
		if (this.rangeStart) {
			let rangeStart = this.rangeStart
				.replace('HH', '00')
				.replace('mm', '00')
				.replace('ss', '00');
			let startParts = rangeStart.split(':');
			return [...Array(24 - Number(startParts[0])).keys()].flatMap(
				(i) => i + Number(startParts[0])
			);
		}
		return [...Array(24 - 0).keys()].flatMap((i) => i + 0);
	}

	get rangeEndMinuteRange(): Number[] {
		if (
			this.rangeStart &&
			!(this.rangeEnd.split(':')[0] > this.rangeStart.split(':')[0])
		) {
			let rangeStart = this.rangeStart
				.replace('HH', '00')
				.replace('mm', '00')
				.replace('ss', '00');
			let startParts = rangeStart.split(':');
			return [...Array(60 - Number(startParts[1])).keys()].flatMap(
				(i) => i + Number(startParts[1])
			);
		}
		return [...Array(60 - 0).keys()].flatMap((i) => i + 0);
	}

	get rangeEndSecondRange(): Number[] {
		if (
			this.rangeStart &&
			!(this.rangeEnd.split(':')[0] > this.rangeStart.split(':')[0]) &&
			!(this.rangeEnd.split(':')[1] > this.rangeStart.split(':')[1])
		) {
			let rangeStart = this.rangeStart
				.replace('HH', '00')
				.replace('mm', '00')
				.replace('ss', '00');
			let startParts = rangeStart.split(':');
			return [...Array(60 - (Number(startParts?.[2] || 0) + 1)).keys()].flatMap(
				(i) => i + (Number(startParts?.[2] || 0) + 1)
			);
		}
		return [...Array(60 - 0).keys()].flatMap((i) => i + 0);
	}

	get rangeEndError(): Boolean {
		if (this.rangeStart && this.rangeEnd) {
			let start = this.rangeStart.split(':');
			let end = this.rangeEnd.split(':');
			const sDate = new Date(
				0,
				0,
				0,
				Number(start[0]),
				Number(start[1]),
				Number(start?.[2] || 0)
			);
			const eDate = new Date(
				0,
				0,
				0,
				Number(end[0]),
				Number(end[1]),
				Number(end[2] || 0)
			);
			if (eDate > sDate) {
				return false;
			} else {
				return true;
			}
		}
		return false;
	}


}
